<template>
    <div v-if="canEditEmail">
        <v-row align="center" no-gutters>
            <v-col>
                <div class="text-caption secondary--text font-weight-medium mb-1" v-if="enabledEditEmail">
                    Informe seu e-mail para liberar/encerrar o carregamento e envio do recibo.
                </div>
            </v-col>
        </v-row>
        <v-row align="center" no-gutters>
            <v-col>
                <v-text-field type="email" v-model="email" :rules="[rules.email]" required :append-icon="enabledEditEmail ? '' : 'edit'" :readonly="!enabledEditEmail"
                    @keydown.enter="clickEmail" @click:append="clickEmail" ref="emailField" dense hide-details="auto" light/>
            </v-col>

            <v-col cols="auto" v-if="enabledEditEmail">
                <v-btn small color="success" class="ml-2" @click="clickEmail" v-if="enabledEditEmail">
                    <v-icon left small v-if="$vuetify.breakpoint.smAndUp">mdi-content-save</v-icon>
                    Salvar
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import rules from "@/helpers/rules";

export default {
    name: "Email",

    data() {
        return {
            rules,
            email: null,
            canEditEmail: true,
            editMode: false,
        };
    },

    mounted() {
        this.getPreference();
        this.$eventHub.$on("makeLogin", this.getPreference);
    },

    computed: {
        enabledEditEmail() {
            return this.canEditEmail && (this.editMode || this.email == null || this.email == "");
        }
    },

    methods: {
        emitEvent() {
            this.$store.commit("CHANGE_PAYMENT_EMAIL", this.email);
            this.$eventHub.$emit("changePaymentEmail");
        },
        clickEmail() {
            if (this.enabledEditEmail == false) {
                this.editMode = true;
                this.email = "";
                this.emitEvent();
            } else {
                const emailField = this.$refs.emailField;
                if (emailField && emailField.validate()) {
                    this.editMode = false;
                    this.emitEvent();
                } else {
                    this.$eventHub.$emit("msgWarning", "Email inválido");
                }
            }
        },
        savePreference() {
            if (this.tab) {
                this.method = this.tab;
            }
            this.$store.commit("CHANGE_PAYMENT_METHOD", this.method);
        },
        getPreference() {
            if (this.$store.state.login.email) {
                this.canEditEmail = false;
            } else if (this.$store.state.payment.email) {
                this.email = this.$store.state.payment.email;
            } else {
                this.editMode = true;
            }
        },
    }
};
</script>